import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Logistic } from "../../../../model/logistic";

@Component({
  selector: 'aw-create-logistic',
  templateUrl: './create-logistic-dialog.component.html',
  styleUrls: ['./create-logistic-dialog.component.scss']
})
export class CreateLogisticDialogComponent implements OnInit {


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Logistic,
    public dialogRef: MatDialogRef<CreateLogisticDialogComponent>
  ) {


  }

  ngOnInit(): void {

  }


}


